<template>
  <div class="pt-1" style="max-width: 80%; margin: auto">
    <div class="b-full-width d-flex justify-end">
      <b-language-dropdown
        @change="reloadPage"
      />
    </div>
    <b-reg-flow
      :instance="instance"
      :dangerously-disable-security-checks="dangerouslyDisableSecurityChecks"
      name="regFlow"
      @finished="sendSuccess"
    />
  </div>
</template>

<script>
export default {
  name: "Home",
  data: () => ({
    instance: {},
    loadingProgress: 0,
    instance_id: window.bomconfig.fallback_instance_id,
    module: window.bomconfig.module,
    dangerouslyDisableSecurityChecks: false,
    regmask_listeners: [],
  }),
  async created() {
    this.dangerouslyDisableSecurityChecks = !!(window.bomconfig?.dangerzone?.disable_security_checks);
    const q_client_id = this.$route.query.client;
    const q_language = this.$route.query.language;
    const language_to_set = localStorage.getItem("blang") || q_language || language || "de";
    const {
      api_url, api_token, language, client_name, client_id, cookie_name, cache_max_age,
    } = window.bomconfig;
    this.$bom.init(api_url, api_token, {
      language: language_to_set,
      client_id: q_client_id || client_id,
      client_name,
      cookie_name,
      cache_max_age,
    });
    this.$i18n.locale = language_to_set;
    if (window.bomconfig.color) {
      this.$bomify.$vuetify.theme.themes.light.primary = window.bomconfig.color;
    }
    this.instance_id = this.$route.query.id || this.instance_id;
    this.module = this.$route.query.module || this.module;
    this.instance = await this.fetchInstance();
    this.instance.ClientPlugin.select();
    this.loadingProgress = 15;

    window.addEventListener("message", (event) => {
      if (!window.bomconfig.trust_messages_from.includes(event.origin)) { return; }
      if (event.data === "RegMask NotifyMe") {
        this.regmask_listeners.push({source: event.source, origin: event.origin});
      }
    }, false);
  },
  methods: {
    sendSuccess() {
      const topic = this.$bomify.$message.constructor.TOPICS.REG_MASK;
      this.$bomify.$message.send(topic, topic.success);
    },
    async fetchInstance() {
      const { instance } = await this.$bom[this.module].instances.one
        .withId(this.instance_id)
        .including("TagsPlugin", "IncidentPlugin", "AddressRelationsPlugin")
        .fetch();
      return instance;
    },
    reloadPage() {
      location.reload();
    },
    finished() {
      this.regmask_listeners.forEach((target) => {
        target.source.postMessage("Registration Successful", target.origin);
      });
    },
  },
};
</script>

<style scoped>
.lang-switch {
  float: right;
}
</style>
